export default __webpack_public_path__ + "static/media/puzzle.ef81d9fd.png";